enum RouteNames {
  NIKON = "/",
  CREATE_CLAIM = "/create-claim",
}

export default RouteNames;
